export class Codec{}